import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import DialogConfirm from '../../../../dialog/DialogConfirm';
import { Alert } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonDownload from '../../../../button/ButtonDownload';
import ButtonStartIcon from '../../../../button/ButtonStartIcon';
import usePeriodicalReport from '../../../../../hooks/periodical-report/usePeriodicalReport';
import { useParams } from 'react-router-dom';

const DialogGenerateXML = ({ open, onClose }) => {
  const { periodicalReportId } = useParams();
  const [form, setInputForm] = useState({});
  const [errors, setInputErrors] = useState(null);
  const [loading, toggleLoading] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState('');

  const onChange = (name, value) => {
    setInputForm({ ...form, [name]: value });
    setInputErrors({ ...errors, [name]: null });
  };

  const { generatePeriodicalReportXML } = usePeriodicalReport();

  const onSave = async (e) => {
    e.preventDefault();
    toggleLoading(true);
    try {
      let result = await generatePeriodicalReportXML(periodicalReportId, form);
      if (result.error) {
        setInputErrors(result);
      } else {
        setDownloadUrl(result.path);
      }
    } finally {
      toggleLoading(false);
    }
  };

  return (
    <DialogConfirm
      id={'generate-xml-data'}
      open={open}
      title='generate xml'
      onCancel={onClose}
      onConfirm={undefined}
      loading={loading}
      maxWidth='xs'
    >
      <div className='flex flex-col items-center gap-4'>
        <Typography>To generate the PRS212 XML FILE, it is necessary to import the PRS211 XML FILE.</Typography>
        <Typography color={form?.file?.[0]?.name ? 'primary' : 'textSecondary'}>
          {form?.file?.[0]?.name || 'No file selected'}
        </Typography>
        {form.file ? (
          <>
            {downloadUrl ? (
              <ButtonDownload filename={downloadUrl}>
                <ButtonStartIcon
                  startIcon={'download'}
                >
                  Download PRS212 XML
                </ButtonStartIcon>
              </ButtonDownload>
            ) : (
              <ButtonStartIcon
                onClick={onSave}
                disabled={loading}
                startIcon='check'
                loading={loading}
              >
                Generate PRS212 XML
              </ButtonStartIcon>
            )}
          </>
        ) : (
          <>
            <label
              for='file-upload'
              className='btn-primary rounded cursor-pointer flex items-center gap-2 px-4 py-2'
            >
              <FontAwesomeIcon icon={['fas', 'upload']} size='lg' />
              <span className=''>Upload PRS211 XML</span>
            </label>
            <input
              id='file-upload'
              type='file'
              name='file'
              error={errors?.file}
              style={{ display: 'none' }}
              onChange={(e) => onChange('file', e.target.files)}
            />
          </>
        )}
      </div>
      {errors && errors.message && (
        <Alert severity='error' className='mt-2' onClose={() => setInputErrors({ message: null })}>
          {errors.message}
        </Alert>
      )}
    </DialogConfirm>
  );
};

export default DialogGenerateXML;
